import { render } from "./nextcloud_body_banner3.vue?vue&type=template&id=c232d5a6&scoped=true"
import script from "./nextcloud_body_banner3.vue?vue&type=script&lang=js"
export * from "./nextcloud_body_banner3.vue?vue&type=script&lang=js"

import "./nextcloud_body_banner3.vue?vue&type=style&index=0&id=c232d5a6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c232d5a6"]])

export default __exports__